import Vue from 'vue';
import axios from 'axios'; 
import Vddl from 'vddl';

Vue.use(Vddl);

export default {
  name: 'GisMapSettings',
  data: function () {
    return {
      map: { id: 0, Workspace: -1, name: '', description: '', backgroundLayerType: -1, customBackground: '' },
      workspaces: [],
      //backgroundLayerTypes: [],
      isInComm: false,
      message: '',
      layersCompData: { Src: [], Dst: [] },
      selectedItems: { Src: [], Dst: [] },
    }
  },
  created() {
    var mapId = this.$route.params.id;
    this.getWorkspaces();
    // this.getBackgroundLayerTypes();

    if (mapId > 0)
      this.getMap(mapId);
  },
  computed: {
    workspace: function () {
      if (this.map)
        return this.map.workspace;
      return '';
    },
  },
  watch: {
    workspace: function (value) {
      this.getLayers(value);
    }
  },
  methods: {
    getWorkspaces() {
      axios.post('/GIS/GetWorkspaces')
        .then(response => {
          if (response.data.data.status == 0) {
            this.workspaces = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getMap(id) {
      axios.post('/GIS/GetMap', {Value: id})
        .then(response => {
          if (response.data.data.status == 0) {
            this.map = response.data.item;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    saveMap() {
      axios.post('/GIS/SaveMap', {
        Id: this.map.id, ServerType: this.map.serverType, BackgroundLayerType: this.map.backgroundLayerType,
        Name: this.map.name, Description: this.map.description, CustomBackground: this.map.customBackground,
        Workspace: this.map.workspace, Layers: this.layersCompData.Dst
      })
        .then(response => {
          if (response.data.data.status == 0) {
            this.closeWithMessage(this.$t('messages.MapSavedSuccess'), 0, 1500);
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getLayers(workspace) {
      axios.post('/GIS/GetLayers', { MapId: this.map.id, Workspace: workspace })
        .then(response => {
          if (response.data.data.status == 0) {
            this.layersCompData.Dst = response.data.mapLayers;
            this.layersCompData.Src = response.data.availableLayers;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    close() {
      this.$router.go(-1);
    },
    selectSrc(item) {
      var idx = this.selectedItems.Src.indexOf(item);
      if (idx < 0)
        this.selectedItems.Src.push(item);
      else
        this.selectedItems.Src.splice(idx, 1);        
    },
    isSelectedSrc(item) {
      return this.selectedItems.Src.indexOf(item) >= 0 ? 'selected' : '';
    },
    selectDst(item) {
      var idx = this.selectedItems.Src.indexOf(item);
      if (idx < 0)
        this.selectedItems.Dst.push(item);
      else
        this.selectedItems.Dst.splice(idx, 1);
    },
    isSelectedDst(item) {
      return this.selectedItems.Dst.indexOf(item) >= 0 ? 'selected' : '';
    },
    moveLeft() {
      var items = this.selectedItems.Dst;
      items.forEach((item) => {
        this.layersCompData.Src.push(item);
        var idx = this.layersCompData.Dst.indexOf(item);
        this.layersCompData.Dst.splice(idx, 1);
      });
      this.selectedItems.Dst = [];
    },
    moveLeftAll() {
      var items = this.layersCompData.Dst;
      items.forEach((item) => {
        this.layersCompData.Src.push(item);
      });
      this.layersCompData.Dst = [];
      this.selectedItems.Dst = [];
    },
    moveRight() {
      var items = this.selectedItems.Src;
      items.forEach((item) => {
        this.layersCompData.Dst.push(item);
        var idx = this.layersCompData.Src.indexOf(item);
        this.layersCompData.Src.splice(idx, 1);
      });
      this.selectedItems.Src = [];
    },
    moveRightAll() {
      var items = this.layersCompData.Src;
      items.forEach((item) => {
        this.layersCompData.Dst.push(item);
      });
      this.layersCompData.Src = [];
      this.selectedItems.Src = [];
    },
    //getBackgroundLayerTypes() {

    //},
    closeWithMessage(msg, type, timeout = 3000) {
      this.message = msg;
      if (type == 1)
        this.message += ' If the problem repeats please contact Support';
      this.$alertMsg(msg);
      setTimeout(function () { this.close(); }.bind(this), timeout);
    },
  },

}
